'use client';

import React from 'react';
import { Input, Label } from './';

interface TimeInputProps {
  id: string;
  label: string;
  value: string; // Format: "HH:MM" (24-hour format)
  onChange: (value: string) => void;
  required?: boolean;
  className?: string;
}

export function TimeInput({ id, label, value, onChange, required, className }: TimeInputProps) {
  // For type="time", we just need to ensure the format is HH:MM
  const formatForInput = (timeValue: string) => {
    if (!timeValue) return '';
    // Ensure the time is in HH:MM format
    if (timeValue.includes(':')) {
      return timeValue.padStart(5, '0');
    }
    return timeValue;
  };

  // For type="time", the input value is already in HH:MM format
  const formatFromInput = (inputValue: string) => {
    if (!inputValue) return '';
    return inputValue; // Already in HH:MM format
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const timeValue = formatFromInput(e.target.value);
    onChange(timeValue);
  };

  return (
    <div className={className}>
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        type="time"
        value={formatForInput(value)}
        onChange={handleChange}
        required={required}
      />
    </div>
  );
}
